// with polyfills
import 'regenerator-runtime/runtime';
import 'virtual:svg-icons-register';
import mitt from 'mitt';
import { setupAntd, setupGlobalMethods } from '~/pluginFun';
import { store } from '@/store/index';
import pinia from '@/store/store';
import myStorage from '~/utils/storage';
import { storeToRefs } from 'pinia';
import { ApiGetContent } from '@/api/content';
import { addColor } from '~/utils/style/addcolor';
import { formatFlight } from '@/utils/formatData';
import { ApiGetAirportsCountrylist, ApiGetCurrency, ApiGetCarrier, ApiGetAirportsList } from '@/api/baseData';
import { getOrderPriceVerify } from '@/api/createOrder';
let piniaStore = store(pinia);

const { getLang, getCurrency } = storeToRefs(piniaStore);

const langValue = computed(() => {
    if (process.client) {
        return getLang.value.toLowerCase();
    } else {
        return 'En';
    }
});
const nuxtAppValue = ref();

function getCountryListAirportsListFun(nuxtApp: any) {
    ApiGetAirportsCountrylist({}).then((res) => {
        getCarrierFun(nuxtApp);
        if (res) {
            let { data, status } = res;
            if (status == 0) {
                if (data) {
                    piniaStore.setCountryList(data);
                }
            }
        }
    });
}
function getCurrencyList(nuxtApp: any) {
    ApiGetCurrency({ cid: useRuntimeConfig().public.nuxtChannelId }).then((res) => {
        getContentFun(1, nuxtApp);
        let { datas, defaultCurrency, status } = res;
        if (status === 0) {
            piniaStore.setCurrencyList(datas);
            if (!myStorage.getStore('currency')) {
                piniaStore.setCurrency(defaultCurrency);
            }
        }

    });
}
function getContentFun(num: number, nuxtApp: any) {
    ApiGetContent({ lang: langValue.value, currency: piniaStore.getCurrency }).then((res: any) => {
        if (num == 1) {
            getCountryListAirportsListFun(nuxtApp);
        }
        if (res) {
            let { theme } = res;
            if (theme) {
                if (process.client) {
                    addColor(theme);
                }

            }
            piniaStore.setContent(res);
        }
    });
}
function getCarrierFun(nuxtApp: any) {
    ApiGetCarrier().then((res: any) => {
        console.log(nuxtApp, 'nuxtApp');
        console.log(nuxtApp._route);
        console.log(nuxtApp.$i18n);
        const localeRoute = useLocaleRoute();
        const routePathStr = nuxtApp._route.path;

        let objRes: any = {};
        if (res && res.length > 0) {
            piniaStore.setCarrierList(res);
            for (var i = 0; i < res.length; i++) {
                objRes[res[i].airlineCode2] = {
                    airlineNameCn: res[i].airlineNameCn,
                    airlineNameEn: res[i].airlineNameEn,
                    airlineNameHk: res[i].airlineNameHk,
                };
            }
            piniaStore.setCarrierObj(objRes);
            if (routePathStr) {
                const routePathArr = routePathStr.split('/');
                if (routePathArr.length > 0) {
                    const routePathName = routePathArr[2];
                    if (routePathName === 'flightLoading') {
                        getOrderPriceVerifyFun(nuxtApp._route, nuxtApp.$i18n.locale, localeRoute);
                    }
                }

            }
        }

    });
}
// flightLoading接口
function getOrderPriceVerifyFun(route: any, locale: any, localeRoute: any) {
    piniaStore.setSpin(true);
    piniaStore.setToken(Date.now().toString());
    piniaStore.setUserInfo({ uid: '-1', uname: '' });
    piniaStore.setCurrency(route.query.currency as string);
    piniaStore.setLang(locale.value as string);
    let otaReferenceId = '';
    if (route.query.skyscanner_redirectid) {
        otaReferenceId = route.query.skyscanner_redirectid as string;
    }
    let params = {
        cid: route.query.cid,
        data: route.query.data,
        returnSearch: true,
        otaReferenceId: otaReferenceId
    };
    getOrderPriceVerify(params).then(res => {
        if (res && res.length > 0) {
            const { routing, airports, currency, diffAmt, language, rule, maxSeats, searchCondition, searchRoutings, sessionId, msg, status, cerrorMsg, ok } = JSON.parse(res as string);
            piniaStore.setAesCryptoStr(ok);
            if (status == 0) {
                let { adultNum, childNum, infantNum, laborNum, seamanNum, studentNum } = searchCondition;
                if (searchRoutings) {
                    let searchRoutingsData = [searchRoutings];
                    if (searchRoutingsData.length > 0) {
                        let formData = formatFlight(
                            searchRoutingsData,
                            {
                                adultNum,
                                childNum,
                                infantNum,
                                laborNum,
                                seamanNum,
                                studentNum,
                            },
                            airports
                        );
                        piniaStore.setCondition(searchCondition);
                        if (Number(diffAmt) < 5) {
                            piniaStore.setCurrentFlight(formData?.flightList[0]);
                            piniaStore.setPriceCheckData({
                                diffAmt: diffAmt,
                                maxSeats: maxSeats,
                                routing: routing,
                                rule: rule,
                                sessionId: sessionId,
                                status: status,
                                msg: msg,
                            });
                            const routePath = localeRoute({
                                path: '/addPassenger',
                            });
                            if (routePath) {
                                return navigateTo(routePath.fullPath); // 路由跳转
                            }
                        }
                    }
                    piniaStore.setSpin(false);
                }
            } else {
                handlePriceCheckFalse(route, locale, localeRoute);
            }
        }
    });

}
async function handlePriceCheckFalse(route: any, locale: any, localeRoute: any) {
    let dataStr = route.query.data as string;
    let tempData = dataStr.split('_');
    let count = tempData[8] * 1 + tempData[9] * 1 + tempData[10] * 1;
    let cabinGrade = tempData[11];
    let fromCityList: any = await ApiGetAirportsList({
        lang: locale.value,
        keys: tempData[3],
    });
    let fromCity: any;
    for (let i in fromCityList.data) {
        if (fromCityList.data[i].cityCode == tempData[3]) {
            fromCity = fromCityList.data[i].cityName;
            break;
        }
    }
    let toCityList: any = await ApiGetAirportsList({
        lang: locale.value,
        keys: tempData[4],
    });
    let toCity: any;
    for (let i in toCityList.data) {
        if (toCityList.data[i].cityCode == tempData[4]) {
            toCity = toCityList.data[i].cityName;
            break;
        }
    }
    let requestData = {
        adultNum: tempData[8] * 1,
        childNum: tempData[9] * 1,
        infantNum: tempData[10] * 1,
        studentNum: 0,
        seamenNum: 0,
        helperNum: 0,
        fromDate: tempData[5].substr(0, 4) + '-' + tempData[5].substr(4, 2) + '-' + tempData[5].substr(6, 2),
        retDate: tempData[6] ? tempData[6].substr(0, 4) + '-' + tempData[6].substr(4, 2) + '-' + tempData[6].substr(6, 2) : '',
        fromCity: { cityCode: tempData[3], cityName: fromCity },
        fromCityType: 1,
        toCity: { cityCode: tempData[4], cityName: toCity },
        toCityType: 1,
        cabinGrade: [cabinGrade],
        ticketType: 1,
        tripType: tempData[7] == 1 ? 1 : 2,
        count: count,
    };
    piniaStore.setCondition(requestData);
    const routePath = localeRoute({
        path: '/searchLoading',
        query: {
            ...requestData,
            fromCity: requestData.fromCity.cityCode,
            toCity: requestData.toCity.cityCode,
            fromDate: requestData.fromDate.replace(/-/g, ''),
            retDate: requestData.tripType == 2 ? '' : requestData.retDate.replace(/-/g, ''),
        },
    });
    return navigateTo(routePath.fullPath);
}
export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.$router.options.scrollBehavior = (to, from, savedPosition: any) => {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    };
    nuxtAppValue.value = nuxtApp;
    const app: any = nuxtApp.vueApp;
    // 注册全局常用的ant-design-vue组件
    setupAntd(app);
    // 注册全局方法
    setupGlobalMethods(app);
    if (process.client) {
        getCurrencyList(nuxtApp);
    }
    return {
        provide: {
            nuxtBaseLinkPath: useRuntimeConfig().public.nuxtBaseLinkPath,
            nuxtShowStudent: Number(useRuntimeConfig().public.NUXT_SHOW_STUDENT),
            nuxtShowSeaman: Number(useRuntimeConfig().public.NUXT_SHOW_SEAMAN),
            nuxtShowLabor: Number(useRuntimeConfig().public.NUXT_SHOW_LABOR),
            mitt: mitt()
        }
    };
});